import { render } from "./ForumsCreateThread.vue?vue&type=template&id=4ba649c2"
import script from "./ForumsCreateThread.vue?vue&type=script&lang=js"
export * from "./ForumsCreateThread.vue?vue&type=script&lang=js"

import "./ForumsCreateThread.vue?vue&type=style&index=0&id=4ba649c2&lang=css"

import exportComponent from "/home/runner/work/web-frontend-dev/web-frontend-dev/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__